export const SET_PERMISSIONS = "SET_PERMISSIONS"

export interface iPermission {
  _id: string
  name: string
}

export interface SetPermissionsAction {
  type: typeof SET_PERMISSIONS
  payload: Array<iPermission>
}

export type PermissionsActionTypes = SetPermissionsAction
